import { create } from "zustand";

interface SpinningWheelDialogStore {
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useSpinningWheelDialogStore = create<SpinningWheelDialogStore>((set, _get) => ({
  isOpen: false,
  handleOpen: () => set({ isOpen: true }),
  handleClose: () => {
    set({ isOpen: false });
  },
}));
